module.exports = __webpack_public_path__ + "static/media/eclipse.79b6a3a6.svg";